// extracted by mini-css-extract-plugin
module.exports = {"subServices":"Subservices_subServices__v59rY"};